import { useEffect } from "react";

export function useClickOutside(ref, callback, ignoreIds = []) {
  useEffect(() => {
    function handleClick(event) {
      // Ignore clicks inside the target ref
      if (ref.current && ref.current.contains(event.target)) {
        return;
      }

      // Ignore clicks if the clicked element OR any parent has an ID in ignoreIds
      for (let id of ignoreIds) {
        const elWithId = event.target.closest(`#${id}`);
        if (elWithId) return;
      }

      callback();
    }

    document.addEventListener("mousedown", handleClick);
    document.addEventListener("touchstart", handleClick);

    return () => {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("touchstart", handleClick);
    };
  }, [ref, callback, ignoreIds]);
}
